module.exports = "<!-- Sidebar -->\n<app-header [tipoMenu]=\"tipoMenuValue\"></app-header>\n<app-grupo-perguntas></app-grupo-perguntas>\n            "